<template>
  <div class="home-page" style="padding-top: 0;">
		<div class="login-content">
      <div class="login login-send">
        <div class="">
          <div class="home-prize">
            <div class="home1">
                <div class="pt20">
                  <a class="logo" style="text-align: left;margin: 0 20px -80px;position: relative;" href="/"><img src="static/images/logo.png" /></a>
                </div>
              <img src="../../static/images/send.jpg" />
            </div>
          </div>
          <div class="input-div" style="margin-top: -130px;">
            <div class="fs50 crfff mt30" style="width: 90%;margin:0 auto" v-html="$t('Login')"></div>
            <div class="span mt30 fs33 cr0062ff fw7" style="font-weight: 400;margin-bottom: 15px;">{{$t('loginTips')}}</div>
            <div class="input-item mt50">
              <div class="input-item2">
<!--                <span class="app-en">94</span>-->
                <input class="input" v-model="mobile" type="number" placeholder="">
              </div>
            </div>
          </div>
          <div class="ac mt50">
            <button class="button fw7" @click="goLogin">{{$t('Login')}}</button>
          </div>
          <div class="ac otp-b disflex mt100">
            <div style="color: white" class="icon icon2" @click="getType('termsAndCondition')">{{$t('TC')}} <span class="app-en">>></span></div>
            <div style="color: white" class="icon icon2" @click="getType('faq')">{{$t('FAQ')}} <span class="app-en">>></span></div>
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/HeaderTwo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        mobile:'',
        password:'',

      }
    },
    created(){
      if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
      if(this.$route.query.msisdn){
        this.mobile = this.$route.query.msisdn
      }
    },
    methods: {
      getType(type){
          this.$router.push({path:'/'+type,query:{type:type}});
      },
      back(){
        this.$router.go(-1);
      },
      goLogin(){
        let that = this
        if(that.mobile==''){
          that.$utils.alertText(that.$t('loginTips'),60)
          return;
        }
        let mobile = this.mobile
        var code  = this.$route.query.code
        let data ={
          'mobile':mobile,
        }
        that.$parent.loadModal(true);
        //检测号码
        that.$api.post('/api/user/check_user',data,r =>{
          if(r.code==1){
            that.$parent.loadModal(false);
            localStorage.setItem('token',r.data.userinfo.token)
            localStorage.setItem('mobile',r.data.userinfo.mobile)
            that.isShowlogin = false
            that.mobile = ''
            this.$router.push({path:'/'})
          }else if(r.code==-1){
            window.location.href = r.data;
          } else{
            that.$parent.loadModal(false);
            that.$utils.alertText(r.msg,100,3000);
          }
        })

      }
	}
}
</script>
<style scoped>
  .drop-down-content{z-index:9;background:none;}
  .mt100{margin-top:100px;}
  .otp-b{justify-content: space-evenly;}
</style>



// WEBPACK FOOTER //
// src/page/LoginNew.vue